var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var remToPixel = function (value, options) {
    return value * options.remPixelValue();
};
var remToCentimeter = function (value, options) {
    return pixel.cm(remToPixel(value, options));
};
var remToMillimeter = function (value, options) {
    return pixel.mm(remToPixel(value, options));
};
var remToQuarter = function (value, options) {
    return pixel.Q(remToPixel(value, options));
};
var remToInch = function (value, options) {
    return pixel.in(remToPixel(value, options));
};
var remToPica = function (value, options) {
    return pixel.pc(remToPixel(value, options));
};
var remToPoint = function (value, options) {
    return pixel.pt(remToPixel(value, options));
};
var remToEM = function (value, options) {
    return pixel.em(remToPixel(value, options), options);
};
var remToViewWidth = function (value, options) {
    return pixel.vw(remToPixel(value, options), options);
};
var remToViewHeight = function (value, options) {
    return pixel.vh(remToPixel(value, options), options);
};
var remToViewMin = function (value, options) {
    return pixel.vmin(remToPixel(value, options), options);
};
var remToViewMax = function (value, options) {
    return pixel.vmax(remToPixel(value, options), options);
};
export var rem = (_a = {},
    _a[UnitSuffix.Pixel] = remToPixel,
    _a[UnitSuffix.Centimeter] = remToCentimeter,
    _a[UnitSuffix.Millimeter] = remToMillimeter,
    _a[UnitSuffix.Quarter] = remToQuarter,
    _a[UnitSuffix.Inch] = remToInch,
    _a[UnitSuffix.Pica] = remToPica,
    _a[UnitSuffix.Point] = remToPoint,
    _a[UnitSuffix.REM] = noConvert,
    _a[UnitSuffix.EM] = remToEM,
    _a[UnitSuffix.ViewWidth] = remToViewWidth,
    _a[UnitSuffix.ViewHeight] = remToViewHeight,
    _a[UnitSuffix.ViewMin] = remToViewMin,
    _a[UnitSuffix.ViewMax] = remToViewMax,
    _a);
//# sourceMappingURL=rem.js.map